function MB_sleep(t = 1000) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, t);
  });
}
async function MB_jsDeferHandle(method, waitObj = []) {
  for (let i = 0; i < 1000; i++) {
    let status = true;
    for (const item of waitObj) {
      if (!window[item]) {
        status = false;
        break;
      }
    }
    if (status) break;
    await MB_sleep(50);
  }
  method();
}
async function MB_waitElementReady(
  element,
  isExist = true,
  preTime = 10,
  total = 999
) {
  for (let i = 0; i < total; i++) {
    if (
      (document.querySelectorAll(element).length > 0 && isExist) ||
      (document.querySelectorAll(element).length == 0 && !isExist)
    ) {
      break;
    }
    await MB_sleep(preTime);
  }
}
async function MB_apiFetch(url, type = "GET", data = null) {
  const params = {
    method: type,
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
  };
  data && (params["body"] = JSON.stringify(data));
  const response = await fetch(url, params);
  return response.json();
}
function MB_setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function MB_getCookie(cname) {
  const decodedCookie = decodeURIComponent(document.cookie);
  const reg = new RegExp(`${cname}=(.*?);`);
  const res = reg.exec(decodedCookie);
  return res ? res[1] : null;
}
function MB_getUrlParam(paramName) {
  // const regex = new RegExp(`[?&]${paramName}=([^&]*)`, 'g');
  // var match = window.location.search.match(
  // 	'[?&]' + paramName + '(?:&|$|=([^&]*))'
  // );
  // return match ? (match[1] ? match[1] : '') : null;

  const regex = new RegExp(`${paramName}=(.*?)(&|$)`, "g");
  const matches = location.search.match(regex);
  if (matches) {
    const values = matches.map((match) => match.split("=")[1].replace(/&/, ""));
    if (values.length > 1) {
      return values;
    } else {
      return values[0].replace(/&/, "");
    }
  } else {
    return null;
  }
}
// async function onColorSwatchChange() {
//   const el = ".t4s-swatch__item.mibao_many_line_color";
//   await MB_waitElementReady(el);
//   $(el).click(function () {
//     const color = $(this).text();
//     const title = $(this).prevAll("h4").first();
//     $(".mibao-swatch__current").text("");
//     title.find(".mibao-swatch__current").text(color);
//   });
// }

(function () {
  function checkLoginedCart() {
    if (window.location.search.includes('open_cart=1')) {
      T4SThemeSP.Drawer.opend($('#t4s-mini_cart'))
    }
  }

  // 监听mini cart元素变化
  async function watchMiniCartAndShowDiscountInfo() {
    // let is_code_apply = false;
    $(window).on("cart:inited", () => {
      window.handleCartChange('#t4s-mini_cart');
      checkLoginedCart();
    });
    $(window).on("cart:updated", () => {
      window.handleCartChange('#t4s-mini_cart');
      window.handleCartChange('.t4s-main-cart')
      checkLoginedCart();
    });
    // await MB_waitElementReady(
    //   "#t4s-mini_cart .mibao_coupon_input .t4s-field button",
    //   (preTime = 500),
    //   (total = 100)
    // );

    // $("#t4s-mini_cart .mibao_coupon_input .t4s-field input").on(
    //   "keydown",
    //   function () {
    //     $("#t4s-mini_cart .mibao_coupon_input .tips").hide(300);
    //   }
    // );
    // $("#t4s-mini_cart .mibao_coupon_input .t4s-field button").click(
    //   async function () {
    //     $("#t4s-mini_cart .mibao_coupon_input .t4s-field button").attr(
    //       "disabled",
    //       true
    //     );
    //     const code = $("#t4s-mini_cart .mibao_coupon_input input").val();
    //     if (code) {
    //       $(
    //         "#t4s-mini_cart [data-cart-discounts] .t4s-cart_discounts"
    //       ).remove();
    //       $("#t4s-mini_cart[data-cart-wrapper]").addClass("is--contentUpdate");
    //       $("#t4s-mini_cart [data-cart-item]").addClass("is--update");
    //       $("#t4s-mini_cart [data-cart-item]")
    //         .find(".t4s-cart-ld__bar")
    //         .removeAttr("hidden");
    //       $("#t4s-mini_cart [data-cart-item]")
    //         .find(".t4s-cart-spinner")
    //         .removeAttr("hidden");

    //       await $.get(`/discount/${code}`);
    //       await MB_sleep(100);
    //       await T4SThemeSP.Cart.getToFetch();
    //       is_code_apply = true;

    //       $("#t4s-mini_cart[data-cart-wrapper]").removeClass(
    //         "is--contentUpdate"
    //       );
    //       $("#t4s-mini_cart [data-cart-item]").removeClass("is--update");
    //       $("#t4s-mini_cart [data-cart-item]")
    //         .find(".t4s-cart-ld__bar")
    //         .attr("hidden", "");
    //       $("#t4s-mini_cart [data-cart-item]")
    //         .find(".t4s-cart-spinner")
    //         .attr("hidden", "");
    //     }
    //     $(this).removeAttr("disabled");
    //     // await MB_waitElementReady('#t4s-mini_cart [data-cart-discounts] .t4s-cart_discounts', preTime=50, total=30)
    //     // await MB_sleep(1500)
    //   }
    // );
    // function show_tips() {
    //   if (
    //     $("#t4s-mini_cart [data-cart-discounts] .t4s-cart_discounts").length
    //   ) {
    //     $("#t4s-mini_cart .mibao_coupon_input .tips").hide(300);
    //   } else {
    //     let tips = "";
    //     if (
    //       $("#t4s-mini_cart .t4s-mini_cart__item .t4s-cart_discount_price")
    //         .length
    //     ) {
    //       tips = "Saved code. Click to checkout.";
    //     } else {
    //       tips = "Invalid code. Redeem Gift Card at checkout.";
    //     }
    //     $("#t4s-mini_cart .mibao_coupon_input .tips").text(tips);
    //     $("#t4s-mini_cart .mibao_coupon_input .tips").hide().show(300);
    //   }
    // }
  }
  // 包装袋添加
  async function cartGiftWrapHandle() {
    await MB_waitElementReady("[data-mibao-cart-gift-wrap-submit]");
    $("[data-mibao-cart-gift-wrap-submit]").click(async function (e) {
      e.preventDefault();
      $(this).next(".mibao-tips").hide();
      $(this).addClass("is--loading").attr("aria-disabled", true);
      const items = [];
      $(".mibao_cart_gift_wrap")
        .find("[data-cart-item]")
        .each(function () {
          const id = $(this).attr("data-variant-id");
          const quantity = parseInt(
            $(this)
              .find("[data-quantity-wrapper]")
              .find("[data-quantity-value]")
              .val()
          );
          if (quantity > 0) {
            items.push({
              id,
              quantity,
            });
          }
        });
      if (!items.length) {
        $(this).next(".mibao-tips").text("You must add A Box!!");
        $(this).next(".mibao-tips").show();
      } else {
        const data = {
          sections:
            location.pathname == "/cart"
              ? "cart_data,main-cart"
              : "cart_data,mini_cart",
          sections_url: location.pathname,
          items,
        };
        const response = await MB_apiFetch(
          `${T4Sroutes.cart_add_url}.js`,
          "POST",
          data
        );
        window.mibaoCartData = response;
        await MB_sleep(500);
        const o = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: `application/javascript`,
            "X-Requested-With": "XMLHttpRequest",
          },
        };
        o.body = JSON.stringify(data);
        $(document).trigger("add:cart:success", [o]).trigger("add:cart:upsell");

        window.mibaoCartData = response;
        await MB_sleep(500);
        T4SThemeSP.Cart.renderContents(response.sections);
      }
      $(this).removeClass("is--loading").removeAttr("aria-disabled");
    });
  }

  // 修改产品右上角标的显示条件
  async function setProductBadges() {
    await MB_waitElementReady(
      ".bg_color_ntloading",
      (isExist = false),
      (preTime = 50)
    );
    $("[data-product-single-badge]").each(function () {
      const data = $(this)
        .parents("[data-product-featured]")
        .data("product-featured");
      if (!data.available) {
        $("[data-main-media] .flickityt4s-viewport").css(
          "--showProductSoldOutBadge",
          "flex"
        );
      }
    });
    $(".t4s-product-wrapper:not(.is-mibao-checked)").each(function () {
      const parent = $(this);
      const data = parent.closest(".t4s-product").data("product-options");

      if (!data) {
        parent.addClass("is-mibao-checked");
        return;
      }

      const sizingTypeSize = Number(data.sizingType_size) || 0;
      const hasBadge =
        sizingTypeSize > 1 || data.isNew || data.isSellingFast || data.isBackIn;

      if (!hasBadge) {
        parent.addClass("is-mibao-checked");
        return;
      }

      const productImage = parent
        .find(".t4s-product-inner .t4s-product-img")
        .first();

      if (!productImage.length) {
        return;
      }

      let badgeContainers = "";
      if (!parent.find(".mibao_badge_left_top").length) {
        badgeContainers += "<div class='mibao_badge_left_top'></div>";
      }
      if (!parent.find(".mibao_badge_left_bottom").length) {
        badgeContainers += "<div class='mibao_badge_left_bottom'></div>";
      }
      if (badgeContainers) {
        productImage.after(badgeContainers);
      }

      const badgeTop = parent.find(".mibao_badge_left_top");
      const badgeBottom = parent.find(".mibao_badge_left_bottom");

      if (
        sizingTypeSize > 1 &&
        !badgeTop.find(".t4s-badge-sizing_type").length
      ) {
        const html = `<span class="t4s-badge-item t4s-badge-sizing_type mibao">${sizingTypeSize} lengths</span>`;
        badgeTop.append(html);
      } else if (data.isNew && !badgeTop.find(".t4s-badge-new").length) {
        const html = `<span class="t4s-badge-item t4s-badge-new mibao">NEW</span>`;
        badgeTop.append(html);
      }

      if (
        data.isSellingFast &&
        !badgeBottom.find(".t4s-badge-selling_fast").length
      ) {
        const html = `<span class="t4s-badge-item t4s-badge-selling_fast mibao">BEST SELLER</span>`;
        badgeBottom.append(html);
      }

      if (data.isBackIn && !badgeTop.find(".t4s-badge-back_in").length) {
        const html = `<span class="t4s-badge-item t4s-badge-back_in mibao">BACK IN</span>`;
        badgeTop.append(html);
      }

      parent.addClass("is-mibao-checked");
    });
  }
  // 设置菜单栏
  async function initHeaderMenu() {
    // 阻止头部菜单有二级了菜单的栏目点击动作
    $("header .t4s-navigation a[href='/']").on("click", function (e) {
      e.preventDefault();
    });

    // 展开移动端的菜单栏
    await MB_waitElementReady("ul.t4s-mb__menu li:nth-child(4)");
    await MB_sleep(200);
    // $("ul.t4s-mb__menu>li:nth-child(4)>a").click()

    // 展开底部菜单
    await MB_waitElementReady(
      "#shopify-section-footer .t4s-footer-wrap .t4s-custom-col:nth-child(5) .t4s-footer-heading"
    );
  }
  function onScroll() {
    if (document.querySelector(".bg_color_ntloading") == null) {

      MB_jsDeferHandle(setProductBadges, ["jQuery"]);
    }
  }
  // 倒计时去除0天的显示
  // async function countdownDaysLess1_2() {
  //   await MB_waitElementReady(
  //     ".mibao-countdown .t4s-countdown-enabled .day",
  //     (preTime = 50),
  //     (total = 100)
  //   );
  //   $(".mibao-countdown").each(async function () {
  //     for (let i = 0; i < 100; i++) {
  //       const days = $(this).find(".t4s-countdown-enabled b.day").text();
  //       if (days != "%d") {
  //         if (days == "00" || days == "0") {
  //           $(this).addClass("days_less1");
  //         }
  //         break;
  //       }
  //       await MB_sleep(100);
  //     }
  //   });
  // }

  function addWishListBtnEvent() {
    document.body.addEventListener('click', function (event) {
      const wishListBtn = event.target.closest('.t4s-pr-wishlist');
      if (!wishListBtn) {
        return
      }
      const productId = wishListBtn.dataset.id;
      if (wishListBtn.classList.contains("is--added") || wishListBtn.dataset.hasOwnProperty("removeWishlist")) {
        Shopify.analytics.publish("wishlist", {
          event_type: 'remove_wishlist',
          productId: productId
        });
        return
      }
      Shopify.analytics.publish("wishlist", {
        event_type: 'add_wishlist',
        productId: productId
      });
    })
  }

  function init() {
    MB_jsDeferHandle(initHeaderMenu, ["jQuery"]);
    MB_jsDeferHandle(setProductBadges, ["jQuery"]);
    MB_jsDeferHandle(watchMiniCartAndShowDiscountInfo, ["jQuery"]);
    MB_jsDeferHandle(addWishListBtnEvent, ["jQuery"]);
    MB_jsDeferHandle(cartGiftWrapHandle, ["jQuery"]);
    // MB_jsDeferHandle(countdownDaysLess1_2, ["jQuery"]);
    window.addEventListener(
      "scroll",
      () => {
        onScroll();
      },
      false
    );
  }
  MB_jsDeferHandle(init, ["jQuery"]);

  // 从url参数中提取数据，记录到cookies
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  MB_setCookie("click_id", urlParams.get("click_id"), 7);
  MB_setCookie("offer_id", urlParams.get("offer_id"), 7);
  // frequently-bought-together 加购后处理
  document.addEventListener(
    "codeblackbelt:frequently-bought-together:added",
    async function (event) {
      await T4SThemeSP.Cart.getToFetch();
      T4SThemeSP.Drawer.opend($("#t4s-mini_cart"));
    }
  );
})();
